import Container from './Container';

import texas from './../../../assets/logos/texas.png';
import nyu from './../../../assets/logos/nyu.png';
import harvard from './../../../assets/logos/harvard.png';
import edinburgh from './../../../assets/logos/edinburgh.png';
import mit from './../../../assets/logos/mit.png';
import oxford from './../../../assets/logos/oxford.png';

const LOGOS = [
  { src: texas, name: 'University of Texas' },
  { src: nyu, name: 'New York University' },
  { src: harvard, name: 'Harvard University' },
  { src: edinburgh, name: 'University of Edinburgh' },
  { src: mit, name: 'MIT' },
  { src: oxford, name: 'University of Oxford' },
];

const Row = () =>
  LOGOS.map((l, i) => (
    <img
      key={`${l.name}-${i}`}
      src={l.src}
      alt={l.name}
      className="mx-9 h-8 w-auto shrink-0 object-contain opacity-40 transition-opacity duration-300 hover:opacity-90 md:h-9"
    />
  ));

const TrustedBy = () => {
  return (
    <section className="relative py-10 lg:py-14">
      <Container>
        <p className="mb-8 text-center text-[0.78rem] font-medium uppercase tracking-[0.2em] text-white/35">
          Trusted by students at
        </p>
      </Container>

      <div className="marquee-mask relative flex overflow-hidden">
        <div className="flex shrink-0 animate-marquee items-center">
          <Row />
          <Row />
        </div>
      </div>
    </section>
  );
};

export default TrustedBy;
